import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import { firstValueFrom } from "rxjs";

import type { Service } from "@mirage/service-extension-settings/service";

const service = services.get<Service>(ServiceId.EXTENSION_SETTINGS);

export function getIsNewTabEnabled() {
  return firstValueFrom(service.getIsNewTabEnabled());
}

export function setIsNewTabEnabled(enabled: boolean) {
  return firstValueFrom(service.setIsNewTabEnabled(enabled));
}

export function getIsActionBarEnabled() {
  return firstValueFrom(service.getIsActionBarEnabled());
}

export function setIsActionBarEnabled(enabled: boolean) {
  return firstValueFrom(service.setIsActionBarEnabled(enabled));
}
